import { breakpoints } from '../../primitives/tokens';

export const getColumnWidthAndOffset = (
    columnCount: number,
    columnGapPixels: number,
    subgroupLength: number,
): {
    widthPercent: number,
    offsetPixels: number
} => {
    if (subgroupLength > columnCount) {
        // We're subdividing to fit the space available
        const totalGapSize = columnGapPixels * (subgroupLength - 1); // The column count - 1, because we only care about the spaces
        const individualGapDecrement = totalGapSize / subgroupLength; // The width adjustment per col for even gapping
        const colPcSize = 100 / subgroupLength;
        return {
            widthPercent: colPcSize,
            offsetPixels: individualGapDecrement,
        };
    }

    const totalGapSize = columnGapPixels * (columnCount - 1); // The column count - 1, because we only care about the spaces
    const individualGapDecrement = totalGapSize / columnCount; // The width adjustment per col for even gapping

    const columnsInItem = Math.max(1, subgroupLength);

    const colPcSize = 100 / columnCount;
    const columnWidth = Math.min(columnsInItem * colPcSize, columnCount * colPcSize); // Max it out at the max column count

    const skippedColumnIncr = columnGapPixels / 4; // The unit we need to use to compensate for the gap not existing, when columns > 1

    const offsetPx = individualGapDecrement - (skippedColumnIncr * columnsInItem) + skippedColumnIncr;

    return {
        widthPercent: columnWidth,
        offsetPixels: offsetPx,
    };
};

export const getHeaderContentWidth = (
    maxDropdownSize: number,
    childMenuLength: number,
    maxAvailableColumns: number,
): string => `min(${
    Math.max(
        1,
        Math.min(childMenuLength === (maxAvailableColumns - 1) ? maxAvailableColumns : childMenuLength, maxAvailableColumns),
    ) * (maxDropdownSize / maxAvailableColumns)}px, ${
    Math.max(
        1,
        Math.min(childMenuLength === (maxAvailableColumns - 1) ? maxAvailableColumns : childMenuLength, maxAvailableColumns),
    ) * (98.5 / maxAvailableColumns)}vw)`;

export const atTabletBreakpoint = (styles: Record<string, unknown>): Record<string, unknown> => ({
    [breakpoints.tb]: {
        '.is-microsite &': {
            ...styles,
        },
    },
    [breakpoints.headerTb]: {
        'not:(.is-microsite) &': {
            ...styles,
        },
    },
});
